/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {ProgressBarLineModel} from './models/progress-bar-line.model';

@Component({
    selector: 'app-progress-bar-line',
    templateUrl: './progress-bar-line.component.html',
    styleUrls: ['./progress-bar-line.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ProgressBarLineComponent {
    @Input() progressBar: ProgressBarLineModel;

    get applyStyle(): { [key: string]: string } {
        return {'width':`${this.progressBar?.percentage}%`, 'background': this.progressBar?.lineBackgroundColor};
    }
}
